module.exports = __webpack_public_path__ + "static/scale-model-of-juven-tours-&-travel-inc-in-fargo-north-dakota-a88b5aaaf97a9fcdd7d234bc53eb2634.png";